
import { store } from '@/utils/';
import { setting, menu } from '@/config/config'
import dataDict from '@/config/dataDict'

export default {
	areaOption: [],//缓存地区信息
	scoreItem: store.get('scoreItem') || null,
  setting,
  menu,
  dataDict,
  subDomain: store.get('subDomain') || null,
};